import schedulesViewStateStore from "../../store/store";
import { IShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('UPDATE_SHIFTS_IN_VIEW', function updateShiftsInView(
    shiftsInView: IShiftEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    let shifts: ObservableMap<string, IShiftEntity> = viewState ? viewState.shiftsInView : schedulesViewStateStore().shiftsInView;
    for (let i = 0; i < shiftsInView.length; i++) {
        shifts.set(shiftsInView[i].id, shiftsInView[i]);
    }
});
